import { render } from "./UpitnikIzvestaj.vue?vue&type=template&id=9539a7d6&scoped=true"
import script from "./UpitnikIzvestaj.vue?vue&type=script&lang=js"
export * from "./UpitnikIzvestaj.vue?vue&type=script&lang=js"

import "./UpitnikIzvestaj.vue?vue&type=style&index=0&id=9539a7d6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9539a7d6"

export default script